import { _ as _objectWithoutProperties, d as _objectSpread2, a as _extends } from '../_rollupPluginBabelHelpers-b0164b33.js';
import React from 'react';
import PropTypes from 'prop-types';
import Bem from '../packages/honey-bem.js';
import { Injecss } from '../packages/injecss.js';

var styles = {
raw: ".hcr-btn-arrow-1-6-0{display:inline-block;position:relative;min-height:0;border:0;background:transparent;color:#444;font-family:Roboto Condensed,Arial,sans-serif;font-size:18px;font-weight:400;line-height:24px;text-decoration:none;cursor:pointer}.hcr-btn-arrow-1-6-0:active,.hcr-btn-arrow-1-6-0:focus,.hcr-btn-arrow-1-6-0:hover{text-decoration:none}.hcr-btn-arrow-1-6-0:after{display:inline-block;width:24px;height:24px;content:\"\";vertical-align:middle;background:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1000 1000'%3E%3Cpath d='M365.9 763.6a28.2 28.2 0 010-40.4l216.4-216.4a8.2 8.2 0 000-13.6L365.9 276.8a28.6 28.6 0 0140.5-40.4l216.3 218.1a66.4 66.4 0 0119.6 45.5 66.4 66.4 0 01-19.6 45.5L406.4 763.6a28.2 28.2 0 01-40.5 0z' fill='rgba(51, 51, 51, 0.99)'/%3E%3C/svg%3E\") no-repeat 50%}.hcr-btn-arrow--back-1-6-0:after{display:none}.hcr-btn-arrow--back-1-6-0:before{display:inline-block;width:24px;height:24px;content:\"\";vertical-align:middle;background:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1000 1000'%3E%3Cpath d='M636.4 236.4a28.2 28.2 0 010 40.4L417.7 493.2a8.2 8.2 0 000 13.6l218.7 216.4a28.6 28.6 0 01-40.5 40.4L377.3 545.5a66.4 66.4 0 01-19.6-45.5 66.4 66.4 0 0119.6-45.5l216.3-218.1a28.2 28.2 0 0142.8 0z' fill='rgba(51, 51, 51, 0.99)'/%3E%3C/svg%3E\") no-repeat 50%}.hcr-btn-arrow--top-1-6-0:after{-webkit-transform:rotate(-90deg);transform:rotate(-90deg)}.hcr-btn-arrow--bottom-1-6-0:after{-webkit-transform:rotate(90deg);transform:rotate(90deg)}.hcr-btn-arrow--strong-1-6-0{color:#ffad00}.hcr-btn-arrow--strong-1-6-0:after{background:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1000 1000'%3E%3Cpath d='M365.9 763.6a28.2 28.2 0 010-40.4l216.4-216.4a8.2 8.2 0 000-13.6L365.9 276.8a28.6 28.6 0 0140.5-40.4l216.3 218.1a66.4 66.4 0 0119.6 45.5 66.4 66.4 0 01-19.6 45.5L406.4 763.6a28.2 28.2 0 01-40.5 0z' fill='rgba(255, 173, 0, 0.99)'/%3E%3C/svg%3E\") no-repeat 50%}.hcr-btn-arrow--strong-1-6-0.hcr-btn-arrow--back-1-6-0:before{background:url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1000 1000'%3E%3Cpath d='M636.4 236.4a28.2 28.2 0 010 40.4L417.7 493.2a8.2 8.2 0 000 13.6l218.7 216.4a28.6 28.6 0 01-40.5 40.4L377.3 545.5a66.4 66.4 0 01-19.6-45.5 66.4 66.4 0 0119.6-45.5l216.3-218.1a28.2 28.2 0 0142.8 0z' fill='rgba(255, 173, 0, 0.99)'/%3E%3C/svg%3E\") no-repeat 50%}",
map:{"hcr-btn-arrow":"hcr-btn-arrow-1-6-0","hcr-btn-arrow--back":"hcr-btn-arrow--back-1-6-0","hcr-btn-arrow--top":"hcr-btn-arrow--top-1-6-0","hcr-btn-arrow--bottom":"hcr-btn-arrow--bottom-1-6-0","hcr-btn-arrow--strong":"hcr-btn-arrow--strong-1-6-0"}};

var bem = Bem('btn-arrow', styles);
var ButtonArrow = function ButtonArrow(_ref) {
  var appearance = _ref.appearance,
      children = _ref.children,
      direction = _ref.direction,
      Elem = _ref.Elem,
      RouterLink = _ref.RouterLink,
      extraClasses = _ref.extraClasses,
      rest = _objectWithoutProperties(_ref, ["appearance", "children", "direction", "Elem", "RouterLink", "extraClasses"]);

  // if type button nullify type
  var computedtype = Elem !== 'button' ? null : _objectSpread2({}, rest).type; // create main block class

  var blockClass = bem.b([appearance, direction], extraClasses);
  var WrapperElement = RouterLink !== null ? RouterLink : Elem;
  return React.createElement(WrapperElement, _extends({
    className: blockClass,
    type: computedtype
  }, rest), children);
};
ButtonArrow.displayName = 'ButtonArrow';
ButtonArrow.defaultProps = {
  appearance: null,
  direction: null,
  Elem: 'a',
  RouterLink: null,
  extraClasses: ''
};
ButtonArrow.propTypes = {
  /** Appearance to be applied */
  appearance: PropTypes.oneOf([null, 'strong']),

  /** Content of the button */
  children: PropTypes.node.isRequired,

  /** Direction of arrow icon */
  direction: PropTypes.oneOf([null, 'bottom', 'back', 'top']),

  /** Defines wrapping element */
  Elem: PropTypes.oneOf(['button', 'a', 'span']),

  /** Wraps your Button inside a RouterLink, e.g. if you use ReactRouter or a similar library.
  * If this prop is provided the Elem prop is beeing ignored */
  RouterLink: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),

  /** Injection in className */
  extraClasses: PropTypes.string
};
var ButtonArrow$1 = Injecss(ButtonArrow, styles);

export { ButtonArrow$1 as ButtonArrow };
